import { render, staticRenderFns } from "./modalEditarVigencia.vue?vue&type=template&id=d80003b4&scoped=true"
import script from "./modalEditarVigencia.vue?vue&type=script&lang=js"
export * from "./modalEditarVigencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d80003b4",
  null
  
)

export default component.exports